import { KrCard } from '@/common/card/KrCard';
import { EntityForm } from '@/common/entityFramework/entityForm/EntityForm';
import { EntityTabs } from '@/common/entityFramework/entityTabs/EntityTabs';
import { useEntityMgr } from '@/common/entityFramework/entityView/EntityMgrContext';
import { EntityAuditCard } from '@/common/form/cards/EntityAuditCard';
import { EntitySectionCard } from '@/common/form/cards/EntitySectionCard';
import { EntityStatusCard } from '@/common/form/cards/EntityStatusCard';
import { ScrollableSpacerLayoutArea } from '@/common/layout/ScrollableSpacerLayoutArea';
import { Spacer, SpacerLayout } from '@/common/layout/SpacerLayout';
import { CustCotList } from '../custCot/CustCotList';
import { CustIdentList } from '../custIdent/CustIdentList';

export const CustForm = () => {
  const { entityObj } = useEntityMgr();

  return (
    <EntityForm>
      <SpacerLayout>
        <Spacer weights={[3, 1]}>
          <ScrollableSpacerLayoutArea>
            <EntitySectionCard title="General" />
            <KrCard variant="soft" fill>
              <EntityTabs
                id="custRelated"
                tabSpecs={[
                  { id: 'custIdent', label: 'Identifiers', content: <CustIdentList custId={entityObj.id} /> },
                  { id: 'custCot', label: 'Classes of Trade', content: <CustCotList custId={entityObj.id} /> },
                ]}
              />
            </KrCard>
          </ScrollableSpacerLayoutArea>
          <ScrollableSpacerLayoutArea>
            <EntityStatusCard />
            <EntityAuditCard />
          </ScrollableSpacerLayoutArea>
        </Spacer>
      </SpacerLayout>
    </EntityForm>
  );
};
